import ReferralsIcon from "assets/svgComponents/referralsPage/ReferralsIcon";
import QuestionMark from "assets/svgComponents/statsBlock/QuestionMark";
import clsx from "clsx";
import { shadowAndBorderClass } from "screens/Dashboard/utils/classes";

export const QuestionButton = ({
  label,
  link,
  isQuestion,
}: {
  label: string;
  link: string;
  isQuestion?: boolean;
}) => {
  return (
    <a className="relative flex w-full" target="_blanc" href={link === "" ? undefined : link}>
      <div
        className={clsx(
          "flex bg-[#161616] items-center justify-between pl-[1.11vw] max-lg:pl-[4.27vw] pr-[0.56vw] max-lg:pr-[2.13vw] py-[0.56vw] max-lg:py-[2.13vw] w-full rounded-[1.11vw] max-lg:rounded-[4.3vw] before:!rounded-[1.11vw] max-lg:before:!rounded-[4.3vw]",
          shadowAndBorderClass,
        )}
      >
        <div className="w-fit font-luxora-medium text-white text-16 max-lg:text-16m text-center tracking-[0] leading-[110%] whitespace-nowrap">
          {label}
        </div>
        <div
          className={clsx(
            "bg-[#252525] rounded-[0.56vw] max-lg:rounded-[1.6vw] w-[2.22vw] max-lg:w-[8.53vw] h-[2.22vw] max-lg:h-[8.53vw] flex items-center justify-center before:!rounded-[0.56vw] max-lg:before:!rounded-[1.6vw]",
            shadowAndBorderClass,
          )}
        >
          {isQuestion ? (
            <QuestionMark className="max-lg:w-[5.06vw] max-lg:h-[5.06vw]" />
          ) : (
            <ReferralsIcon className="max-lg:w-[5.06vw] max-lg:h-[5.06vw]" />
          )}
        </div>
      </div>
    </a>
  );
};
